import { defineComponent as _defineComponent } from 'vue'
import type { ProfileInfoFragment } from '@/features/user-profile/graphql/fragments/ProfileInfo.fragment';

import UserBadge from '@/features/user-profile/components/UserBadge.vue';

import { clickOnAuthor } from '@/pages/editorial/tracking';
import { influencerIds } from '@/features/user-profile/types';

import { computed } from 'vue';
import { ProfileType } from '@/@types/graphql-types';
import { faCheck } from '@fortawesome/free-solid-svg-icons';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileBox',
  props: {
    profile: null,
    customProfileType: null,
    isHeader: { type: Boolean },
    hideBadge: { default: () => [] },
    hideAllBadges: { type: Boolean },
    size: null,
    linkProfile: { type: Boolean, default: true },
    isBadgeInline: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as { profile: ProfileInfoFragment, customProfileType?: string, isHeader?: boolean, hideBadge: ProfileType[], hideAllBadges?: boolean, size?: 'xsmall' | 'small' | 'large', linkProfile: boolean, isBadgeInline?: boolean };



const isInfluencer = computed(
	() => props.profile.profileType === ProfileType.Influencer || influencerIds.includes(props.profile.id)
);

return { __sfc: true,props, isInfluencer, UserBadge, clickOnAuthor, faCheck }
}

})